var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zg-module',_vm._b({staticClass:"zg-text-section",attrs:{"full-width":_vm.fullWidth || _vm.splitContent}},'zg-module',_vm.moduleProps,false),[_vm._t("sub-title",null,{"slot":"sub-title"}),_vm._v(" "),_c('div',{class:['zg-text-section__container', {
      'zg-text-section__container--with-aside': _vm.hasAside
    }]},[_c('div',{class:['zg-text-section__body', {
        'zg-text-section__body--split': _vm.splitContent,
        'zg-text-section__body--full-width': _vm.fullWidth || _vm.splitContent
      }]},[_vm._t("body")],2),_vm._v(" "),(_vm.hasAside)?_c('aside',[_vm._t("aside")],2):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }